import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import { StepperProvider as StepperCtxProvider, StepperList as Stepper } from './stepper';
import Step1Container from './Step1';
import Step2Container from './Step2';
import Step3Container from './Step3';
import Step4Container from './Step4';
import PublishStatusContainer from './publishStatus';
import { BlockedUserGuard } from './blockedUser/blockedUser';
import { ModalDispatcher } from './Modals/modalDispatcher';

function Publicador() {
  return (
    <>
      <ModalDispatcher />
      <StepperCtxProvider>
        <BlockedUserGuard />
        <Stepper />
        <Switch>
          <Route path='/publicador' exact>
            <Redirect to='/publicador/principales' />
          </Route>
          <Route path='/publicador/principales'>
            <Step1Container />
          </Route>
          <Route path='/publicador/multimedia'>
            <Step2Container />
          </Route>
          <Route path='/publicador/extras'>
            <Step3Container />
          </Route>
          <Route path='/publicador/planes'>
            <Step4Container />
          </Route>
          <Route path='/publicador/status'>
            <PublishStatusContainer />
          </Route>
        </Switch>
      </StepperCtxProvider>
    </>
  );
}

export { Publicador };
